import Nav from "./nav"
import EasyTabs from "./jquery.easytabs"
import Tabs from "./tabs"
import Slider from "./slider"


document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    EasyTabs(jQuery)
    Tabs(jQuery)
    Slider(jQuery)
})
